import React, { useState, useEffect, useRef } from 'react'
import { Input, Button, Card, Modal, Form, message, Select } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import _ from 'lodash'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import {
  paginationInit,
  formatMessageNew,
  initCurryingObj,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  initValueAndLabel,
  uniqueFun,
  dateFormatYearMonthDay
} from '@/utils/common'
import { modalConfirm, modalError } from '@/utils/modalUtils'
import { hasPermission } from '@/annotations/nike-react'
import {
  tunnelMachineSave,
  tunnelMachineUpdate,
  getTunnelMachineQuery,
  tunnelMachineModifyStatus,
  getSiteTypeAndName,
  exportTunnelPage,
  getSiteTypeOrNameOrPlant
} from '@/services/rfid/rfidConfig/rfidStore'
import { getVendor } from '@/services/rfid/rfidConfig/rfidTunnelMachine'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import { CONFIG_STATUS } from '@/utils/types'
import { resIPV4 } from '@/utils/regUtils'
const statusObj = initCurryingObj(CONFIG_STATUS)
const menu_rfid_configuration_tunnelMachine = 'menu_rfid_configuration_tunnelMachine'
const TunnelMachinePage = () => {
  let languageState = useSelector(state => state.commonStore.language)
  const [newModalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [statusFlag, setStatusFlag] = useState(false)
  const [siteList, setSiteList] = useState([])
  const [siteNameList, setSiteNameList] = useState([])
  const [plantList, setPlantList] = useState([])
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [vendorList, setVendorList] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const mounting = useRef(false)
  let formRef = useRef(null)
  let editItemInfo = useRef({})
  let editItemFlag = useRef(false)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.rfidConfiguration.tunnelMachineCode',
      key: 'tunnelMachineCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.rfidConfiguration.tunnelMachineIp',
      key: 'ipAddress',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.siteType',
      key: 'siteType',
      allowClear: true,
      initialValues: null,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.siteName',
      key: 'siteName',
      allowClear: true,
      initialValues: null,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.plant',
      key: 'plant',
      allowClear: true,
      initialValues: null,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.tunnelMachineStatus',
      key: 'status',
      allowClear: true,
      initialValues: null,
      selectList: CONFIG_STATUS,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidConfiguration.vendor',
      key: 'vendor',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidConfiguration.createDate',
      key: 'rangeDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidConfiguration.tunnelMachineCode'),
      dataIndex: 'tunnelMachineCode'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.tunnelMachineIp'),
      dataIndex: 'ipAddress'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.siteType'),
      dataIndex: 'siteType'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.siteName'),
      dataIndex: 'siteName'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.plant'),
      dataIndex: 'plant'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.vendor'),
      dataIndex: 'vendor'
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.tunnelMachineStatus'),
      dataIndex: 'status',
      render: text => statusObj[text]
    },
    {
      title: formatMessageNew('languageObj.rfidConfiguration.createTime'),
      dataIndex: 'createTime'
    },
    {
      title: formatMessageNew('languageObj.commonLocale.operation'),
      dataIndex: 'operation',
      align: 'center',
      render: (text, record) => (
        <div>
          <Button
            disabled={!hasPermission(menu_rfid_configuration_tunnelMachine)}
            type="link"
            size="small"
            onClick={() => {
              addAndEditRecord(record)
            }}
          >
            {formatMessageNew('languageObj.commonLocale.edit')}
          </Button>
        </div>
      )
    }
  ]
  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getSelectOptions()
    getSelectOptions2()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (selectedRowKeys.length === 0 && statusFlag) setStatusFlag(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys])

  const addAndEditRecord = record => {
    setVisibleFlag(true)
    if (record) {
      editItemFlag.current = true
      editItemInfo.current = record
      newModalForm.setFieldsValue(record)
      getSiteNameListByType(record.siteType)
      getPlantListByName(record.siteName)
    } else {
      editItemFlag.current = false
      editItemInfo.current = {}
      newModalForm.resetFields()
    }
  }
  const getSelectOptions = () => {
    Promise.all([
      getSiteTypeOrNameOrPlant({ type: 1 }),
      getSiteTypeOrNameOrPlant({ type: 2 }),
      getSiteTypeOrNameOrPlant({ type: 3 }),
      getVendor()
    ]).then(res => {
      if (res && res.length > 0) {
        searchListInit.forEach(itemFirst => {
          let arr = []
          if (
            itemFirst.key === 'siteType' ||
            itemFirst.key === 'siteName' ||
            itemFirst.key === 'plant' ||
            itemFirst.key === 'vendor'
          ) {
            if (itemFirst.key === 'siteType') {
              arr = res[0].resultData || []
            }
            if (itemFirst.key === 'siteName') {
              arr = res[1].resultData || []
            }
            if (itemFirst.key === 'plant') {
              arr = res[2].resultData || []
            }
            if (itemFirst.key === 'vendor') {
              arr = res[3].resultData || []
              setVendorList(arr)
            }
            itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
          }
        })
        setSearchList([...searchListInit])
      }
    })
  }
  const getSelectOptions2 = () => {
    getSiteTypeAndName().then(res => {
      if (res) {
        let siteLs = res.resultData
        setSiteList(siteLs)
        searchListInit.forEach(itemFirst => {
          const arr = []
          if (itemFirst.key === 'siteType') {
            const dt = siteLs || []
            for (let index = 0; index < dt.length; index++) {
              const element = dt[index]
              arr.push({
                label: element.siteType,
                value: element.siteType
              })
            }
            itemFirst.selectList = arr
          }
        })
        setSearchList([...searchListInit])
      }
    })
  }
  const siteTypeChange = e => {
    newModalForm.setFieldsValue({ siteName: null, plant: null })
    getSiteNameListByType(e)
  }
  const getSiteNameListByType = e => {
    let nameLs = siteList.find(item => item.siteType === e) || {}
    let siteNameList = nameLs.siteNameList || []
    let uniqueRes = siteNameList.map(eachItem => eachItem.siteName)
    setSiteNameList(uniqueRes || [])
  }
  const siteNameChange = e => {
    newModalForm.setFieldsValue({ plant: null })
    getPlantListByName(e)
  }
  const getPlantListByName = e => {
    const formInfo = newModalForm.getFieldValue() || {}
    let nameLs = siteList.find(item => item.siteType === formInfo.siteType) || {}
    let siteNameList = nameLs.siteNameList || []
    let plantLs = siteNameList.find(item => item.siteName === e) || {}
    let uniqueRes = plantLs.plantNameList || []
    setPlantList(uniqueRes || [])
  }
  const downLoadFun = () => {
    const params = {
      ...getParams(),
      isChinese: languageState === 'zh_CN' ? true : false
    }
    exportTunnelPage(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const searchDataBtn = () => {
    mounting.current = true
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { rangeDate } = info
    const params = {
      ...info,
      startCreateDate: formatStartTime(rangeDate),
      endCreateDate: formatEndTime(rangeDate)
    }
    delete params.rangeDate
    return params
  }
  const searchDataFun = () => {
    const params = {
      asc: true,
      orderByColumn: '',
      current: pagination.currentPage,
      size: pagination.pageSize,
      param: {
        ...getParams()
      }
    }

    getTunnelMachineQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const disabledDataFun = () => {
    modalConfirm(
      {
        content: statusFlag
          ? formatMessageNew('languageObj.rfidConfiguration.enableTunnelMachineDataTip')
          : formatMessageNew('languageObj.rfidConfiguration.disabledTunnelMachineDataTip')
      },
      () => {
        const params = []
        for (let index = 0; index < tableList.length; index++) {
          const element = tableList[index]
          if (selectedRowKeys.indexOf(element.id) !== -1) {
            params.push({
              tunnelMachineCode: element.tunnelMachineCode,
              ipAddress: element.ipAddress,
              id: element.id,
              status: statusFlag
            })
          }
        }
        tunnelMachineModifyStatus({
          machineConfigurationDtoList: params
        }).then(() => {
          message.success(formatMessageNew('languageObj.commonLocale.success'))
          setSelectedRowKeys([])
          setQueryFlag(!queryFlag)
        })
      }
    )
  }
  const handleUserOk = () => {
    newModalForm
      .validateFields()
      .then(values => {
        const params = {
          ...values,
          status: true
        }
        if (editItemFlag.current) {
          params.id = editItemInfo.current.id
          params.status = editItemInfo.current.status
          tunnelMachineUpdate(params)
            .then(() => {
              message.success(formatMessageNew('languageObj.commonLocale.success'))
              setQueryFlag(!queryFlag)
              setVisibleFlag(false)
            })
            .catch(err => {
              const errorCode = err.errorCode
              let str = 'languageObj.rfidConfiguration.error_' + errorCode
              let strTitle = 'languageObj.rfidConfiguration.error_title_' + errorCode
              modalError({
                title: formatMessageNew(strTitle),
                content: formatMessageNew(str)
              })
            })
        } else {
          tunnelMachineSave(params)
            .then(() => {
              message.success(formatMessageNew('languageObj.commonLocale.success'))
              setQueryFlag(!queryFlag)
              setVisibleFlag(false)
            })
            .catch(err => {
              const errorCode = err.errorCode
              let str = 'languageObj.rfidConfiguration.error_' + errorCode
              let strTitle = 'languageObj.rfidConfiguration.error_title_' + errorCode
              modalError({
                title: formatMessageNew(strTitle),
                content: formatMessageNew(str)
              })
            })
        }
      })
      .catch(errorInfo => {
        console.log('errorInfo', errorInfo)
      })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const onSelectChange = newSelectedRowKeys => {
    const matchedObjects = _.filter(tableList, obj => _.includes(newSelectedRowKeys, obj.id))
    let allFalse = _.every(matchedObjects, ['status', false])
    let allTrue = _.every(matchedObjects, ['status', true])
    if (allFalse) {
      // 全是false则启用
      setStatusFlag(true)
    } else if (allTrue) {
      // 全是true则禁用
      setStatusFlag(false)
    } else {
      // 有true，有false则禁用
      setStatusFlag(false)
    }
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="displayFlex alignCenter justifyContentSB mt10">
          {hasPermission(menu_rfid_configuration_tunnelMachine) && (
            <div>
              <Button
                type="primary"
                style={{ marginLeft: '16px' }}
                onClick={() => {
                  addAndEditRecord()
                }}
              >
                <PlusOutlined />
                {formatMessageNew('languageObj.rfidConfiguration.addTunnelMachine')}
              </Button>
              <Button
                type="primary"
                danger={!statusFlag}
                disabled={!hasSelected}
                style={{ marginLeft: '20px' }}
                onClick={() => {
                  disabledDataFun()
                }}
              >
                {statusFlag
                  ? formatMessageNew('languageObj.rfidConfiguration.enable')
                  : formatMessageNew('languageObj.rfidConfiguration.disabled')}
              </Button>
            </div>
          )}
        </div>
        <div className="content-container overflow_visible">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            onDownload={downLoadFun}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={hasPermission(menu_rfid_configuration_tunnelMachine) && rowSelection}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={
          editItemFlag.current
            ? formatMessageNew('languageObj.rfidConfiguration.editTunnelMachine')
            : formatMessageNew('languageObj.rfidConfiguration.addTunnelMachine')
        }
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{
            span: 8
          }}
          wrapperCol={{
            span: 16
          }}
          initialValues={{}}
        >
          <Form.Item
            rules={[
              {
                required: true
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.tunnelMachineCode')}
            name="tunnelMachineCode"
          >
            <Input disabled={editItemFlag.current} />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: false,
                validator: (_, value) => {
                  if (value) {
                    if (resIPV4.test(value)) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error(formatMessageNew('languageObj.rfidConfiguration.checkIpv4Format'))
                      )
                    }
                  } else {
                    return Promise.resolve()
                  }
                }
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.tunnelMachineIp')}
            name="ipAddress"
          >
            <Input />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: `${formatMessageNew('languageObj.commonLocale.placeholderSelect')} ${formatMessageNew(
                  'languageObj.rfidConfiguration.siteType'
                )}`
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.siteType')}
            name="siteType"
          >
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              onChange={siteTypeChange}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {siteList.map(itemSite => {
                return (
                  <Select.Option key={itemSite.siteType} value={itemSite.siteType}>
                    {itemSite.siteType}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: `${formatMessageNew('languageObj.commonLocale.placeholderSelect')} ${formatMessageNew(
                  'languageObj.rfidConfiguration.siteName'
                )}`
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.siteName')}
            name="siteName"
          >
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              onChange={siteNameChange}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {siteNameList.map(itemSite => {
                return (
                  <Select.Option key={itemSite} value={itemSite}>
                    {itemSite}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: `${formatMessageNew('languageObj.commonLocale.placeholderSelect')} ${formatMessageNew(
                  'languageObj.rfidConfiguration.plant'
                )}`
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.plant')}
            name="plant"
          >
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {plantList.map(item => {
                return (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: `${formatMessageNew('languageObj.commonLocale.placeholderSelect')} ${formatMessageNew(
                  'languageObj.rfidConfiguration.vendor'
                )}`
              }
            ]}
            label={formatMessageNew('languageObj.rfidConfiguration.vendor')}
            name="vendor"
          >
            <Select
              showSearch
              allowClear
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {vendorList.map(item => {
                return (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default TunnelMachinePage
